import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import {
  GetAvailableDatesCapacityInput,
  useAgentAvailableDatesForWeekQuery as QueryType,
} from "@/modules/patients/services/__generated__/useAgentAvailableDatesForWeekQuery.graphql"

const query = graphql`
  query useAgentAvailableDatesForWeekQuery($input: GetAvailableDatesCapacityInput!, $dayOffset: Int!) {
    agentAvailableDatesForWeek(filter: $input, dayOffset: $dayOffset)
  }
`

export const useAgentAvailableDatesForWeekQuery = (
  input: GetAvailableDatesCapacityInput,
  dayOffset: number,
): readonly string[] => {
  const data = useLazyLoadQuery<QueryType>(query, { input, dayOffset }, { fetchPolicy: "network-only" })
  const availableDates: readonly string[] = data.agentAvailableDatesForWeek
  return availableDates
}
